import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Measure from 'react-measure';
import { getAllClients } from 'redux/modules/teamManagement';
import { browserHistory } from 'react-router';
import { connect } from 'react-redux';
import Helmet from 'react-helmet';
import { ListItem } from 'material-ui/List';
import { LeftNavLayout } from 'containers';
import { DataTable, PageHeader, Spinner } from 'components';
import { ClientDetail } from 'containers/Admin';
import * as styles from './Clients.scss';
import makeSelectable, { wrapState } from '../../../helpers/makeMultiSelectList';
import { List } from 'material-ui/List';
var SelectableList = makeSelectable(List);
SelectableList = wrapState(SelectableList);
var PartnerClientDetail = (_dec = connect(function (state) {
  var _ref;

  return _ref = {
    organization: state.organization.current,
    theme: state.theme,
    allClients: state.teamManagement.allClients,
    isLoadingClients: state.teamManagement.isLoadingClients,
    selectedFields: state.teamManagement.selectedClientTableColumns,
    sortColumnName: state.teamManagement.sortColumnName,
    sortColumnDirection: state.teamManagement.sortColumnDirection,
    searchQuery: state.teamManagement.searchQuery,
    filterUserId: state.teamManagement.filterUserId
  }, _defineProperty(_ref, "theme", state.theme), _defineProperty(_ref, "isLoadingClient", state.teamManagement.isLoadingClient), _ref;
}, {
  getAllClients: getAllClients
}), _dec(_class = /*#__PURE__*/function (_Component) {
  _inherits(PartnerClientDetail, _Component);

  var _super = _createSuper(PartnerClientDetail);

  function PartnerClientDetail(props) {
    var _this;

    _classCallCheck(this, PartnerClientDetail);

    _this = _super.call(this, props);
    _this.state = {
      height: 100
    };
    return _this;
  }

  _createClass(PartnerClientDetail, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.allClients && !this.props.allClients.length) {
        this.props.getAllClients({
          orgTypeId: "".concat(this.props.theme.org) === '0' ? 3 : null,
          parentOrganizationId: this.props.theme.org
        });
      }
    }
    /** *******************************************************************************************
     RENDER
    ********************************************************************************************/

  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return /*#__PURE__*/React.createElement(LeftNavLayout, {
        sidebar: "admin",
        wrapStyle: {
          flex: '1 1 auto',
          padding: 0,
          overflow: 'auto'
        },
        appLayoutInnerStyle: {
          display: 'flex',
          flex: '1 1 auto',
          padding: 0,
          overflow: 'hidden',
          height: '100%'
        }
      }, /*#__PURE__*/React.createElement(Helmet, {
        title: "Clients List"
      }), /*#__PURE__*/React.createElement(Measure, {
        whitelist: ['height'],
        onMeasure: function onMeasure(dimensions) {
          _this2.setState({
            height: dimensions.height
          });
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          display: 'flex',
          flex: '0 0 auto',
          height: '100%'
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          borderRight: '1px solid silver',
          flex: '0 0 183px',
          overflow: 'hidden',
          overflowY: 'auto',
          height: this.state.height
        }
      }, this.props.allClients && !!this.props.allClients.length ? /*#__PURE__*/React.createElement(SelectableList, {
        defaultValue: "".concat(this.props.clientId),
        onChange: function onChange() {
          return false;
        },
        style: {
          paddingTop: 0
        }
      }, this.props.allClients.map(function (client, index) {
        return /*#__PURE__*/React.createElement(ListItem, {
          key: "client".concat(client.id),
          value: "".concat(client.id),
          primaryText: client.name,
          onClick: function onClick() {
            browserHistory.push({
              pathname: "/global/clients/".concat(client.id)
            });
          }
        });
      })) : /*#__PURE__*/React.createElement("div", {
        style: {
          position: 'relative',
          height: 75
        }
      }, /*#__PURE__*/React.createElement(Spinner, {
        center: true
      }))), /*#__PURE__*/React.createElement(ClientDetail, {
        isPartnerClientListView: true,
        clientId: this.props.clientId,
        style: {
          paddingTop: 16
        }
      }))));
    }
  }]);

  return PartnerClientDetail;
}(Component)) || _class);
export { PartnerClientDetail as default };